import React, { ReactElement, Suspense, lazy } from "react";
import { Redirect, Route, Switch, BrowserRouter } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Layout from "./components/layout/Layout";
import AuthStore from "./store/AuthStore";
import AppRoute from "./components/route/AppRoute";
const HomePage = lazy(() => import("./pages/HomePage"));
const LoginPage = lazy(() => import("./pages/users/LoginPage"));
const UsersPage = lazy(() => import("./pages/users/UsersPage"));
const UserPage = lazy(() => import("./pages/users/UserPage"));
const QRComponentesPage = lazy(() => import("./pages/componentes/QRComponentesPage"));
const QRComponenteReparadoPage = lazy(() => import("./pages/componentes/QRComponenteReparadoPage"));
const ComponentePage = lazy(() => import("./pages/componentes/ComponentePage"));
const ComponentesPage = lazy(() => import("./pages/componentes/ComponentesPage"));
const EstatusGeneralPage = lazy(() => import("./pages/estatusGeneral/EstatusGeneralPage"));
const OrdenProcesoPage = lazy(() => import("./pages/estatusGeneral/OrdenProcesoPage"));
const RecepcionPage = lazy(() => import("./pages/recepciones/RecepcionPage"));
const AperturaOPPage = lazy(() => import("./pages/AperturaOPPage"));
const BackupPage = lazy(() => import("./pages/BackupPage"));
const EvaluacionPage = lazy(() => import("./pages/EvaluacionPage"));
const ReparacionPage = lazy(() => import("./pages/ReparacionPage"));
const EntregaPage = lazy(() => import("./pages/EntregaPage"));
const EvaluacionReparacionComponenteDetallesEtapaPage = lazy(() => import("./pages/EvaluacionReparacionComponenteDetallesEtapaPage"));
const ConfiguracionesPage = lazy(() => import("./pages/ConfiguracionesPage"));
const LogsPage = lazy(() => import("./pages/LogsPage"));
const EconnectPage = lazy(() => import("./pages/econnect/EconnectPage"));
const PlanificacionesPage = lazy(() => import("./pages/planificaciones/PlanificacionesPage"));
const PlanificacionPage = lazy(() => import("./pages/planificaciones/PlanificacionPage"));
const OchoDimensionesPage = lazy(() => import("./pages/planificaciones/OchoDimensionesPage"));
const PlanificacionesHistoricasPage = lazy(() => import("./pages/planificaciones/PlanificacionesHistoricasPage"));
const MetasObjetivoPage = lazy(() => import("./pages/planificaciones/MetasObjetivoPage"));
const ConfiguracionProgramacionPage = lazy(() => import("./pages/planificaciones/ConfiguracionProgramacionPage"));
const ConfiguracionParejasPage = lazy(() => import("./pages/planificaciones/ConfiguracionParejasPage"));
const ClientesPage = lazy(() => import("./pages/clientes/ClientesPage"));
const DesviacionesPage = lazy(() => import("./pages/desviaciones/DesviacionesPage"));
const LiberacionesPage = lazy(() => import("./pages/calidad/LiberacionesPage"));
const LiberacionDetailPage = lazy(() => import("./pages/calidad/LiberacionDetailPage"));
const InspeccionesIntermediasPage = lazy(() => import("./pages/calidad/InspeccionesIntermediasPage"));
const InspeccionIntermediaDetailPage = lazy(() => import("./pages/calidad/InspeccionIntermediaDetailPage"));
const LiberacionesDashboardPage = lazy(() => import("./pages/calidad/LiberacionesDashboardPage"));
const VpiTornoBalanceoPage = lazy(() => import("./pages/vpiTornoBalanceo/VpiTornoBalanceoPage"));
const VpiTornoBalanceoDashboardPage = lazy(() => import("./pages/vpiTornoBalanceo/VpiTornoBalanceoDashboardPage"));
const ReprocesosPage = lazy(() => import("./pages/calidad/ReprocesosPage"));
const ReprocesoDetailPage = lazy(() => import("./pages/calidad/ReprocesoDetailPage"));
const AnalisisGarantiaPage = lazy(() => import("./pages/calidad/AnalisisGarantiaPage"));
const AnalisisGarantiaDetailPage = lazy(() => import("./pages/calidad/AnalisisGarantiaDetailPage"));
const EstatusLaboratorioPage = lazy(() => import("./pages/laboratorio/EstatusLaboratorioPage"));
const ConfiguracionesLaboratorioPage = lazy(() => import("./pages/laboratorio/ConfiguracionesLaboratorioPage"));
const PlanificacionesLaboratorioPage = lazy(() => import("./pages/laboratorio/PlanificacionesLaboratorioPage"));
const SolicitudTotPage = lazy(() => import("./pages/totLaboratorio/SolicitudTotPage"));
const SolicitudTotDetallePage = lazy(() => import("./pages/totLaboratorio/SolicitudTotDetallePage"));
const CatalogoTotLaboratorioPage = lazy(() => import("./pages/totLaboratorio/CatalogoTotLaboratorioPage"));
const ControlComponentePage = lazy(() => import("./pages/componentes/ControlComponentePage"));
const TwoFactorSetupPage = lazy(() => import("./pages/users/TwoFactorSetupPage"));
const CambiarContrasenaTemporalPage = lazy(() => import("./pages/users/CambiarContrasenaTemporalPage"));

const SgiUserPage = lazy(() => import("./pages/sgi/SgiUserPage"));
const SgiAdminPage = lazy(() => import("./pages/sgi/SgiAdminPage"));
const UnderConstructionPage = lazy(() => import("./pages/UnderConstructionPage"));
const PresupuestoGerenciaPage = lazy(() => import("./pages/presupuestoGerencia/PresupuestoGerenciaPage"));
const SigedMainPage = lazy(() => import("./pages/siged/SigedMainPage"));
const CumplimientoPresupuestoPage = lazy(() => import("./pages/presupuestoGerencia/CumplimientoPresupuestoPage"));
const ReservaSalasPage = lazy(() => import("./pages/reservaSalas/ReservaSalasPage"));
const ReservaSalasAdminPage = lazy(() => import("./pages/reservaSalas/ReservaSalasAdminPage"));
const ExtintoresPage = lazy(() => import("./pages/extintores/ExtintoresPage"));
const ExtintoresAdminPage = lazy(() => import("./pages/extintores/ExtintoresAdminPage"));
const TotDiarioPage = lazy(() => import("./pages/tot/TotDiarioPage"));
const TotAdminPage = lazy(() => import("./pages/tot/TotAdminPage"));
const TotVisualizacionPage = lazy(() => import("./pages/tot/TotVisualizacionPage"));
const CasillerosUserPage = lazy(() => import("./pages/casilleros/CasillerosUserPage"));
const CasillerosAdminPage = lazy(() => import("./pages/casilleros/CasillerosAdminPage"));
const EstatusVibracionesPage = lazy(() => import("./pages/vibraciones/EstatusVibracionesPage"));
const AvisosVibracionesPage = lazy(() => import("./pages/vibraciones/AvisosVibracionesPage"));
const ProyectosIngenieriaPage = lazy(() => import("./pages/ingenieria/ProyectosIngenieriaPage"));
const SolicitudServicioPage = lazy(() => import("./pages/serviciosTerreno/SolicitudServicioPage"));
const SolicitudServicioDashboard = lazy(() => import("./pages/serviciosTerreno/SolicitudServicioDashboard"));
const SolicitudServicioDetallePage = lazy(() => import("./pages/serviciosTerreno/SolicitudServicioDetallePage"));
const CatalogoServicioTerrenoPage = lazy(() => import("./pages/serviciosTerreno/CatalogoServicioTerrenoPage"));
const HtasPrvntUserPage = lazy(() => import("./pages/htasPrvnt/HtasPrvntUserPage"));
const HtasPrvntAdminPage = lazy(() => import("./pages/htasPrvnt/HtasPrvntAdminPage"));
const HtasPrvntJcoPage = lazy(() => import("./pages/htasPrvnt/HtasPrvntJcoPage"));
const ReportesFlashPage = lazy(() => import("./pages/aprRptesFlash/ReportesFlashPage"));
const ReportesFlashAdminPage = lazy(() => import("./pages/aprRptesFlash/ReportesFlashAdminPage"));
const CursosSeguridadPage = lazy(() => import("./pages/cursosSeguridad/CursosSeguridadPage"));
const CursosSeguridadAdminPage = lazy(() => import("./pages/cursosSeguridad/CursosSeguridadAdminPage"));
const EstatusEntregasPage = lazy(() => import("./pages/comercial/EstatusEntregasPage"));
const CargaCombustibleGenPage = lazy(() => import("./pages/serviciosGenerales/CargaCombustibleGenPage"));
const SolicitudPrestamoVehiculoPage = lazy(() => import("./pages/serviciosGenerales/SolicitudPrestamoVehiculoPage"));
const PrestamoVehiculosAdminPage = lazy(() => import("./pages/serviciosGenerales/PrestamoVehiculosAdminPage"));
const VehiculosAdminPage = lazy(() => import("./pages/serviciosGenerales/VehiculosAdminPage"));
const CodificacionISOPage = lazy(() => import("./pages/codificacionISO/CodificacionISOPage"));
const InventarioHardwarePage = lazy(() => import("./pages/inventarioHardware/InventarioHardwarePage"));
const ServiciosSoftwarePage = lazy(() => import("./pages/serviciosSoftware/ServiciosSoftwarePage"));
const ModeladorProcesosPage = lazy(() => import("./pages/modeladorProcesos/ModeladorProcesosPage"));
const PlannerTiPage = lazy(() => import("./pages/plannerTi/PlannerTiPage"));
const ReporteBugsPage = lazy(() => import("./pages/reporteBugs/ReporteBugsPage"));
const ReporteBugsAdminPage = lazy(() => import("./pages/reporteBugs/ReporteBugsAdminPage"));
const EntregaTurnoPage = lazy(() => import("./pages/entregaTurno/EntregaTurnoPage"));
const EntregaTurnoFormPage = lazy(() => import("./pages/entregaTurno/EntregaTurnoFormPage"));
const EntregaTurnoDetallePage = lazy(() => import("./pages/entregaTurno/EntregaTurnoDetallePage"));
const NoConformidadesPage = lazy(() => import("./pages/noConformidades/NoConformidadesPage"));
const NoConformidadFormPage = lazy(() => import("./pages/noConformidades/NoConformidadFormPage"));
const MatricesRiesgoPage = lazy(() => import("./pages/matricesRiesgo/MatricesRiesgoPage"));
const HtasSgiGrciaPage = lazy(() => import("./pages/htasSgiGrcia/HtasSgiGrciaPage"));
const HtasSgiGrciaAdminPage = lazy(() => import("./pages/htasSgiGrcia/HtasSgiGrciaAdminPage"));
const AnalisisFodaPage = lazy(() => import("./pages/analisisFoda/AnalisisFodaPage"));
const ObjetivosCalidadPage = lazy(() => import("./pages/objetivosCalidad/ObjetivosCalidadPage"));
const PartesInteresadasPage = lazy(() => import("./pages/partesInteresadas/PartesInteresadasPage"));
const GestionCalidadAdminPage = lazy(() => import("./pages/gestionCalidad/GestionCalidadAdminPage"));
const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100%'
  }}>
    <Spinner animation="border" role="status" variant="primary">
      <span className="visually-hidden">Cargando...</span>
    </Spinner>
  </div>
);

const App = (): ReactElement => (
  <BrowserRouter>
    <AuthStore>
      <Suspense fallback={<LoadingFallback />}>
        <Switch>
          <Route exact path="/login">
            <LoginPage />
          </Route>
          <Route exact path="/setup-2fa">
            <TwoFactorSetupPage />
          </Route>
          <Route exact path="/cambiar-contrasena">
            <CambiarContrasenaTemporalPage />
          </Route>
          <Route>
            <Layout>
              <Suspense fallback={<LoadingFallback />}>
                <Switch>
                  <AppRoute title="Componente Reparado" exact path="/componentesQR/:_id">
                    <QRComponenteReparadoPage />
                  </AppRoute>
                  <AppRoute title="Componentes - Flujo de Procesos" exact path="/">
                    <HomePage />
                  </AppRoute>
                  <AppRoute title="Administración de usuarios" exact path="/users">
                    <UsersPage />
                  </AppRoute>
                  <AppRoute title="Usuario" exact path="/users/:rut">
                    <UserPage />
                  </AppRoute>
                  <AppRoute title="Usuario" exact path="/users/:currentUser/:rut">
                    <UserPage />
                  </AppRoute>
                  <AppRoute
                    title="Componente"
                    exact
                    path="/componentes/:modeloComponente/descripcion/:descripcionComponente"
                  >
                    <ComponentePage />
                  </AppRoute>
                  <AppRoute
                    title="Hoja de control componente"
                    exact
                    path="/componentes/:modeloComponente/descripcion/:descripcionComponente/controles/:control/:anexo/:nuevoAnexo"
                  >
                    <ControlComponentePage />
                  </AppRoute>
                  <AppRoute title="Componentes" exact path="/componentes">
                    <ComponentesPage />
                  </AppRoute>
                  <AppRoute title="Respaldo de Archivos" exact path="/backup">
                    <BackupPage />
                  </AppRoute>
                  <AppRoute title="Visor SGI" exact path="/visor-sgi">
                    <SgiUserPage />
                  </AppRoute>
                  <AppRoute title="Administración SGI" exact path="/admin-sgi">
                    <SgiAdminPage />
                  </AppRoute>
                  <AppRoute title="Inventario de Hardware" exact path="/inventario-hardware">
                    <InventarioHardwarePage />
                  </AppRoute>
                  <AppRoute title="Servicios de Software" exact path="/servicios-software">
                    <ServiciosSoftwarePage />
                  </AppRoute>
                  <AppRoute title="Planner TI" exact path="/planner-ti">
                    <PlannerTiPage />
                  </AppRoute>
                  <AppRoute title="Reporte de Bugs" exact path="/reporte-bugs">
                    <ReporteBugsPage />
                  </AppRoute>
                  <AppRoute title="Reporte de Bugs — Administración" exact path="/reporte-bugs-admin">
                    <ReporteBugsAdminPage />
                  </AppRoute>
                  {/* «nueva» va antes que «:id»: en el Switch gana la primera que calza. */}
                  <AppRoute title="Entrega de Turno" exact path="/entrega-turno">
                    <EntregaTurnoPage />
                  </AppRoute>
                  <AppRoute title="Entrega de Turno — Nueva" exact path="/entrega-turno/nueva">
                    <EntregaTurnoFormPage />
                  </AppRoute>
                  <AppRoute title="Entrega de Turno — Editar" exact path="/entrega-turno/:id/editar">
                    <EntregaTurnoFormPage />
                  </AppRoute>
                  <AppRoute title="Entrega de Turno — Responder" exact path="/entrega-turno/:id/responder">
                    <EntregaTurnoFormPage />
                  </AppRoute>
                  <AppRoute title="Entrega de Turno" exact path="/entrega-turno/:id">
                    <EntregaTurnoDetallePage />
                  </AppRoute>
                  {/* «nueva» va antes que «:id»: en el Switch gana la primera que calza. */}
                  <AppRoute title="No Conformidades" exact path="/no-conformidades">
                    <NoConformidadesPage />
                  </AppRoute>
                  <AppRoute title="No Conformidad — Nueva" exact path="/no-conformidades/nueva">
                    <NoConformidadFormPage />
                  </AppRoute>
                  <AppRoute title="No Conformidad" exact path="/no-conformidades/:id">
                    <NoConformidadFormPage />
                  </AppRoute>
                  <AppRoute title="Codificación ISO 27001" exact path="/codificacion-iso">
                    <CodificacionISOPage />
                  </AppRoute>
                  <AppRoute title="Herramientas SGI Gerencia" exact path="/herramientas-sgi-gerencia">
                    <HtasSgiGrciaPage />
                  </AppRoute>
                  <AppRoute title="Admin Herramientas SGI Gerencia" exact path="/herramientas-sgi-gerencia-admin">
                    <HtasSgiGrciaAdminPage />
                  </AppRoute>
                  <AppRoute title="Matrices de Riesgos" exact path="/matrices-riesgo">
                    <MatricesRiesgoPage />
                  </AppRoute>
                  <AppRoute title="Gestión de Calidad — Administración" exact path="/gestion-calidad-admin">
                    <GestionCalidadAdminPage />
                  </AppRoute>
                  {/* Las 4 pantallas «Admin …» se fusionaron en /gestion-calidad-admin (2026-10-07). */}
                  <Redirect exact from="/matrices-riesgo-admin" to="/gestion-calidad-admin?tab=matrices" />
                  <AppRoute title="Análisis FODA" exact path="/analisis-foda">
                    <AnalisisFodaPage />
                  </AppRoute>
                  <Redirect exact from="/analisis-foda-admin" to="/gestion-calidad-admin?tab=foda" />
                  <AppRoute title="Plan de Objetivos de Calidad" exact path="/objetivos-calidad">
                    <ObjetivosCalidadPage />
                  </AppRoute>
                  <Redirect exact from="/objetivos-calidad-admin" to="/gestion-calidad-admin?tab=objetivos" />
                  {/* El Modelador de Procesos pasó a Gestión de Calidad como «Mapas de Procesos» (2026-10-08). */}
                  <AppRoute title="Mapas de Procesos" exact path="/mapas-procesos">
                    <ModeladorProcesosPage />
                  </AppRoute>
                  <Redirect exact from="/modelador-procesos" to="/mapas-procesos" />
                  <Redirect exact from="/modelador-procesos-admin" to="/gestion-calidad-admin?tab=procesos" />
                  <AppRoute title="Partes Interesadas" exact path="/partes-interesadas">
                    <PartesInteresadasPage />
                  </AppRoute>
                  <Redirect exact from="/partes-interesadas-admin" to="/gestion-calidad-admin?tab=partes" />
                  <AppRoute
                    title="Componente"
                    exact
                    path="/ordenesProceso/:codigoOP/componente/:modeloComponente/descripcion/:descripcionComponente"
                  >
                    <ComponentePage />
                  </AppRoute>
                  <AppRoute
                    title="Componente"
                    exact
                    path="/ordenesProceso/:codigoOP/componente/:modeloComponente/descripcion/:descripcionComponente/controles/:isReparacion/:anexo/:isNuevoAnexo"
                  >
                    {/* <ComponentePage /> */}
                  </AppRoute>
                  <AppRoute title="Estatus General" exact path="/ordenesProceso">
                    <EstatusGeneralPage />
                  </AppRoute>
                  <AppRoute
                    title="Orden de Proceso"
                    exact
                    path="/ordenesProceso/:codigoOP"
                  >
                    <OrdenProcesoPage />
                  </AppRoute>
                  {/* <AppRoute title = "Orden de Proceso" exact path = '/recepciones/:_id/:codigoOP'>
                                    <OrdenProcesoPage />
                                </AppRoute> */}
                  <AppRoute
                    title="Recepción"
                    exact
                    path="/ordenesProceso/:codigoOP/recepcion"
                  >
                    <RecepcionPage />
                  </AppRoute>
                  {/* <AppRoute title = "Recepciones" exact path = '/recepciones'>
                                    <RecepcionesPage />
                                </AppRoute>
                                <AppRoute title = "Recepción" exact path = '/recepciones/:_id'>
                                    <RecepcionPage />
                                </AppRoute> */}
                  <AppRoute title="Apertura de OPs" exact path="/aperturaOP">
                    <AperturaOPPage />
                  </AppRoute>
                  <AppRoute
                    title="Código QR de Componentes Reparados"
                    exact
                    path="/componentesQR"
                  >
                    <QRComponentesPage />
                  </AppRoute>
                  <AppRoute
                    title="Evaluación de componente"
                    exact
                    path="/ordenesProceso/:codigoOP/evaluacion"
                  >
                    <EvaluacionPage />
                  </AppRoute>
                  <AppRoute
                    title="Etapa de evaluación"
                    exact
                    path="/ordenesProceso/:codigoOP/evaluacion/:etapa"
                  >
                    <EvaluacionReparacionComponenteDetallesEtapaPage />
                  </AppRoute>
                  <AppRoute
                    title="Reparación de componente"
                    exact
                    path="/ordenesProceso/:codigoOP/reparacion/:tabName"
                  >
                    <ReparacionPage />
                  </AppRoute>
                  <AppRoute
                    title="Etapa de reparación"
                    exact
                    path="/ordenesProceso/:codigoOP/reparacion/:etapa/:anexoBase"
                  >
                    <EvaluacionReparacionComponenteDetallesEtapaPage />
                  </AppRoute>
                  <AppRoute
                    title="Entrega de componente"
                    exact
                    path="/ordenesProceso/:codigoOP/entrega"
                  >
                    <EntregaPage />
                  </AppRoute>
                  <AppRoute title="Configuraciones" exact path="/settingsPage">
                    <ConfiguracionesPage />
                  </AppRoute>
                  <AppRoute title="Logs del sistema" exact path="/logs">
                    <LogsPage />
                  </AppRoute>
                  <AppRoute title="Econnect" exact path="/econnect">
                    <EconnectPage />
                  </AppRoute>
                  <AppRoute
                    title="Planificaciones"
                    exact
                    path="/planificacionesERP"
                  >
                    <PlanificacionesPage />
                  </AppRoute>
                  <AppRoute title="8 Dimensiones" exact path="/8-dimensiones">
                    <OchoDimensionesPage />
                  </AppRoute>
                  <AppRoute
                    title="Planificación"
                    exact
                    path="/planificacionesERP/:id"
                  >
                    <PlanificacionPage />
                  </AppRoute>
                  <AppRoute
                    title="Planificación Histórico"
                    exact
                    path="/planificacionesERP/:id/:mes/:year"
                  >
                    <PlanificacionPage />
                  </AppRoute>
                  <AppRoute
                    title="Planificaciones Históricas — Metas"
                    exact
                    path="/planificaciones-historicas"
                  >
                    <PlanificacionesHistoricasPage />
                  </AppRoute>
                  <AppRoute
                    title="Metas Objetivo de Planificación"
                    exact
                    path="/metas-objetivo-planificacion"
                  >
                    <MetasObjetivoPage />
                  </AppRoute>
                  <AppRoute
                    title="Configuración de Programación"
                    exact
                    path="/configuracion-programacion"
                  >
                    <ConfiguracionProgramacionPage />
                  </AppRoute>
                  <AppRoute
                    title="Reglas de Equipos de Trabajo"
                    exact
                    path="/configuracion-parejas"
                  >
                    <ConfiguracionParejasPage />
                  </AppRoute>
                  <AppRoute title="Clientes" exact path="/clientes">
                    <ClientesPage />
                  </AppRoute>
                  <AppRoute title="Desviaciones" exact path="/desviaciones">
                    <DesviacionesPage />
                  </AppRoute>
                  <AppRoute title="Calidad - Liberaciones" exact path="/calidad/liberaciones">
                    <LiberacionesPage />
                  </AppRoute>
                  <AppRoute title="Calidad - Liberación" exact path="/calidad/liberaciones/:codigoOP/:anexo?">
                    <LiberacionDetailPage />
                  </AppRoute>
                  <AppRoute title="Calidad - Inspecciones Intermedias" exact path="/calidad/inspecciones-intermedias">
                    <InspeccionesIntermediasPage />
                  </AppRoute>
                  <AppRoute title="Calidad - Inspecciones Intermedias OP" exact path="/calidad/inspecciones-intermedias/:codigoOP">
                    <InspeccionIntermediaDetailPage />
                  </AppRoute>
                  <AppRoute title="VPI Torno Balanceo" exact path="/vpi-torno-balanceo">
                    <VpiTornoBalanceoPage />
                  </AppRoute>
                  <AppRoute title="VPI Torno Balanceo - Dashboard" exact path="/vpi-torno-balanceo/dashboard">
                    <VpiTornoBalanceoDashboardPage />
                  </AppRoute>
                  <AppRoute title="Calidad - Dashboards" exact path="/calidad/dashboards">
                    <LiberacionesDashboardPage />
                  </AppRoute>
                  <AppRoute title="Calidad - Reprocesos" exact path="/calidad/reprocesos">
                    <ReprocesosPage />
                  </AppRoute>
                  <AppRoute title="Calidad - Reproceso" exact path="/calidad/reprocesos/:id">
                    <ReprocesoDetailPage />
                  </AppRoute>
                  <AppRoute title="Calidad - Análisis de Garantía" exact path="/calidad/analisis-garantia">
                    <AnalisisGarantiaPage />
                  </AppRoute>
                  <AppRoute title="Calidad - Análisis de Garantía" exact path="/calidad/analisis-garantia/:id">
                    <AnalisisGarantiaDetailPage />
                  </AppRoute>
                  <AppRoute title="Laboratorio - Estatus" exact path="/laboratorio/ordenesProceso">
                    <EstatusLaboratorioPage />
                  </AppRoute>
                  <AppRoute title="Laboratorio - Planificaciones" exact path="/laboratorio/planificaciones">
                    <PlanificacionesLaboratorioPage />
                  </AppRoute>
                  <AppRoute title="Laboratorio - Configuraciones" exact path="/laboratorio/configuraciones">
                    <ConfiguracionesLaboratorioPage />
                  </AppRoute>
                  <AppRoute title="Laboratorio - Solicitudes TOT Interno" exact path="/laboratorio/tot-interno">
                    <SolicitudTotPage />
                  </AppRoute>
                  <AppRoute title="Laboratorio - Catálogo TOT Interno" exact path="/laboratorio/catalogo-tot">
                    <CatalogoTotLaboratorioPage />
                  </AppRoute>
                  <AppRoute title="Laboratorio - Detalle Solicitud TOT" exact path="/laboratorio/tot-interno/:id">
                    <SolicitudTotDetallePage />
                  </AppRoute>
                  <AppRoute title="En Construcción" exact path="/en-construccion">
                    <UnderConstructionPage />
                  </AppRoute>
                  {/* Gerencia: pantallas aún en construcción (2026-10-14). */}
                  <AppRoute title="Políticas de la Empresa" exact path="/gerencia/politicas">
                    <UnderConstructionPage />
                  </AppRoute>
                  <AppRoute title="Objetivos de Calidad — Gerencia" exact path="/gerencia/objetivos-calidad">
                    <UnderConstructionPage />
                  </AppRoute>
                  {/* SIGED reemplaza la antigua «Plan Estratégico» (2026-10-27). */}
                  <Redirect exact from="/gerencia/plan-estrategico" to="/gerencia/siged" />
                  <AppRoute title="SIGED Estratégico" exact path="/gerencia/siged">
                    <SigedMainPage />
                  </AppRoute>
                  <AppRoute title="Presupuesto de Gerencia" exact path="/gerencia/presupuesto">
                    <PresupuestoGerenciaPage />
                  </AppRoute>
                  <AppRoute title="Cumplimiento de Presupuesto" exact path="/gerencia/cumplimiento-presupuesto">
                    <CumplimientoPresupuestoPage />
                  </AppRoute>
                  <AppRoute title="Gestión de Proyectos — Ingeniería" exact path="/gestion-proyectos">
                    <ProyectosIngenieriaPage />
                  </AppRoute>
                  <AppRoute title="Reserva de Salas" exact path="/reserva-salas">
                    <ReservaSalasPage />
                  </AppRoute>
                  <AppRoute title="Centro de Aprobación – Salas" exact path="/reserva-salas-admin">
                    <ReservaSalasAdminPage />
                  </AppRoute>
                  <AppRoute title="Control de Extintores" exact path="/extintores">
                    <ExtintoresPage />
                  </AppRoute>
                  <AppRoute title="Administración de Extintores" exact path="/extintores-admin">
                    <ExtintoresAdminPage />
                  </AppRoute>
                  <AppRoute title="Visualización TOT" exact path="/tot-view">
                    <TotVisualizacionPage />
                  </AppRoute>
                  <AppRoute title="Programación Diaria TOT" exact path="/tot">
                    <TotDiarioPage />
                  </AppRoute>
                  <AppRoute title="Administración Listas TOT" exact path="/tot-admin">
                    <TotAdminPage />
                  </AppRoute>
                  <AppRoute title="Distribución de Casilleros" exact path="/casilleros">
                    <CasillerosUserPage />
                  </AppRoute>
                  <AppRoute title="Administración de Casilleros" exact path="/casilleros-admin">
                    <CasillerosAdminPage />
                  </AppRoute>
                  <AppRoute title="Estatus Análisis de Vibraciones" exact path="/analisis-vibraciones">
                    <EstatusVibracionesPage />
                  </AppRoute>
                  <AppRoute title="Configuración de Avisos de Vibraciones" exact path="/avisos-vibraciones">
                    <AvisosVibracionesPage />
                  </AppRoute>
                  <AppRoute title="Solicitud de Servicio a Terreno" exact path="/solicitud-servicio">
                    <SolicitudServicioPage />
                  </AppRoute>
                  <AppRoute title="Dashboard Servicios a Terreno" exact path="/dashboard-servicios-terreno">
                    <SolicitudServicioDashboard />
                  </AppRoute>
                  <AppRoute title="Detalle de Solicitud de Servicio" exact path="/solicitud-servicio/:id">
                    <SolicitudServicioDetallePage />
                  </AppRoute>
                  <AppRoute title="Catálogo Subcomponentes / Servicios" exact path="/catalogo-servicios-terreno">
                    <CatalogoServicioTerrenoPage />
                  </AppRoute>
                  <AppRoute title="Herramientas Preventivas" exact path="/herramientas-preventivas">
                    <HtasPrvntUserPage />
                  </AppRoute>
                  <AppRoute title="Admin Herramientas Preventivas" exact path="/herramientas-preventivas-admin">
                    <HtasPrvntAdminPage />
                  </AppRoute>
                  <AppRoute title="Control JCO" exact path="/herramientas-preventivas-jco">
                    <HtasPrvntJcoPage />
                  </AppRoute>
                  <AppRoute title="Sistema de Reportes Flash" exact path="/reportes-flash">
                    <ReportesFlashPage />
                  </AppRoute>
                  <AppRoute title="Administración de Reportes Flash" exact path="/reportes-flash-admin">
                    <ReportesFlashAdminPage />
                  </AppRoute>
                  <AppRoute title="Cursos de Seguridad" exact path="/cursos-seguridad">
                    <CursosSeguridadPage />
                  </AppRoute>
                  <AppRoute title="Administración de Cursos de Seguridad" exact path="/cursos-seguridad-admin">
                    <CursosSeguridadAdminPage />
                  </AppRoute>
                  <AppRoute title="Estatus de Entregas" exact path="/estatus-entregas">
                    <EstatusEntregasPage />
                  </AppRoute>
                  <AppRoute title="Carga de Combustible Generador 400KVA" exact path="/carga-combustible-generador">
                    <CargaCombustibleGenPage />
                  </AppRoute>
                  <AppRoute title="Solicitud de Préstamo de Vehículos" exact path="/prestamo-vehiculos">
                    <SolicitudPrestamoVehiculoPage />
                  </AppRoute>
                  <AppRoute title="Préstamo de Vehículos — Administración" exact path="/prestamo-vehiculos-admin">
                    <PrestamoVehiculosAdminPage />
                  </AppRoute>
                  <AppRoute title="Gestión de Vehículos" exact path="/gestion-vehiculos">
                    <VehiculosAdminPage />
                  </AppRoute>
                </Switch>
              </Suspense>
            </Layout>
          </Route>
        </Switch>
      </Suspense>
    </AuthStore>
  </BrowserRouter>
);

export default App;
// Force webpack re-index
